"use strict";

exports.__esModule = true;
var isFunction = function isFunction(functionToCheck) {
  return !!(typeof functionToCheck === 'function' && !!functionToCheck.constructor && !!functionToCheck.call && !!functionToCheck.apply);
};
exports["default"] = isFunction;